/*
  ######  ########    ###    ########   ######  ##     ##
 ##       ##        ##   ##  ##     ## ##       ##     ##
  ######  ######   ##     ## ########  ##       #########
       ## ##       ######### ##   ##   ##       ##     ##
  ######  ######## ##     ## ##     ##  ######  ##     ##
*/
const searchInstanceList = document.getElementsByClassName('js-search')
let isSuggestOpen = false
window.addEventListener('click', function (e) {
  // 指定のセレクタに該当する
  if (!isSuggestOpen && e.target.closest('.js-search')) {
    e.target.closest('.js-search').classList.add('active')
    isSuggestOpen = true
    return
  }

  if (isSuggestOpen && !e.target.closest('.js-search.active')) {
    document.querySelector('.js-search.active').classList.remove('active')
    isSuggestOpen = false
  }
})

/*
         ########    ###     ######              ###          ##    ###    ##     ##
            ##     ##   ##  ##                 ##   ##        ##  ##   ##    ## ##
 #######    ##    ##     ## ##   #### ####### ##     ##       ## ##     ##    ###
            ##    ######### ##    ##          ######### ##    ## #########   ## ##
            ##    ##     ##  ######           ##     ##  ######  ##     ## ##     ##
*/
tagAjax()
function tagAjax() {
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  let ajaxWord = ''
  if (document.getElementsByClassName('js-tagAjax')) {
    window.addEventListener('input', (e) => {
      setSend(e)
    })
  }
  function setSend(e) {
    if (e.target.classList.contains('js-tagAjax')) {
      e.preventDefault()
      const item = e.target
      const inputKeyword = item.value.trim() // スペース等を除去した入力内容を取得
      if (ajaxWord === inputKeyword) {
        // キーワードが変わっていなければ処理しない
        return false
      }
      ajaxWord = inputKeyword

      if (ajaxWord === '') {
        // キーワードが空ならクリーンアップ
        const to = item.dataset.to.split(',') // ,区切りで配列に変換

        for (let index = 0; index < to.length; index++) {
          const itemTo = document.querySelector(to[index])
          itemTo.innerHTML = ''
          itemTo.classList.remove('active')
        }
        return
      }

      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const to = item.dataset.to // 差し替え要素
      applyTagAjax(url, to, item.id)
    }
  }

  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param id {string} inputのID
   */
  function applyTagAjax(url, to, id) {
    to = to.split(',') // ,区切りで配列に変換

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    ajax.open('GET', url, true) // GET/POST, URL, 非同期処理
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    ajax.responseType = 'json' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    ajax.send() // リクエスト実行
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (ajax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
        ajaxData = JSON.parse(ajaxData)
      }

      let html = ''

      // 取得したJSONをタグに加工する
      let isHit = false
      for (let index = 0; index < ajaxData.length; index++) {
        const tag = ajaxData[index]

        if (tag === ajaxWord) {
          continue // 入力内容と同じ単語はスキップ
        }
        html += `
<button type="button" class="js-search-insert searchForm__item flex vcenter bet" data-text="${tag}" data-input="${id}">
      ${tag}
</button>
`
        isHit = true
      }

      for (let index = 0; index < to.length; index++) {
        const itemTo = document.querySelector(to[index])
        itemTo.innerHTML = html
        if (isHit) {
          itemTo.classList.add('active')
        } else {
          itemTo.classList.remove('active')
        }
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      ajax = false
    }
  }
}

/*
         #### ##    ##  ######  ######## ########  ########
          ##  ####  ## ##       ##       ##     ##    ##
 #######  ##  ## ## ##  ######  ######   ########     ##
          ##  ##  ####       ## ##       ##   ##      ##
         #### ##    ##  ######  ######## ##     ##    ##
*/

window.addEventListener('click', function (e) {
  // 指定のクラスを持たない
  if (!e.target.classList.contains('js-search-insert')) {
    return
  }

  // サジェストボックスを非表示
  e.target.parentNode.classList.remove('active')

  // 入力を反映
  const inputID = e.target.dataset.input
  const focusInput = document.getElementById(inputID) // フォーカスする入力欄を確定
  focusInput.value = e.target.dataset.text + ' '

  const suggestBox = document.getElementsByClassName('js-search-suggest')
  for (let index = 0; index < suggestBox.length; index++) {
    suggestBox[index].innerHTML = ''
  }

  focusInput.focus() // フォーカスを戻す

  // サジェスト処理を再実行
  ajaxWord = e.target.dataset.text
  const url = focusInput.dataset.url + encodeURI(ajaxWord) // 取得先
  const to = focusInput.dataset.to // 差し替え要素
  applyTagAjax(url, to, inputID)
})

//                ##  ##   ##  ###    ###  #####
//                ##  ##   ##  ## #  # ##  ##  ##
//  ########      ##  ##   ##  ##  ##  ##  #####
//            ##  ##  ##   ##  ##      ##  ##
//             ####    #####   ##      ##  ##

window.addEventListener('click', function (e) {
  // 指定のクラスを持たない
  if (!e.target.classList.contains('js-search-jump')) {
    return
  }
  const input = e.target.dataset.input
  for (const item of searchInputList) {
    item.value = e.target.dataset.text

    item.closest('form').submit() // すぐに飛ぶ
    return
  }
})

//             ####  ##       #####    ####  #####
//            ##     ##      ##   ##  ##     ##
//  ########  ##     ##      ##   ##   ###   #####
//            ##     ##      ##   ##     ##  ##
//             ####  ######   #####   ####   #####
// サジェストを閉じる
window.addEventListener('click', function (e) {
  // 指定のクラスを持たない
  if (!e.target.classList.contains('js-searchSuggestClose')) {
    return
  }
  const suggestList = document.getElementsByClassName('js-search-suggest')
  for (const item of suggestList) {
    item.classList.remove('active')
  }
})

//  ######    ###     ####
//    ##     ## ##   ##
//    ##    ##   ##  ##  ###
//    ##    #######  ##   ##
//    ##    ##   ##   ####
// タグが選択されたらボックスに追加
window.addEventListener('change', function (e) {
  // 指定のクラスを持たない
  if (!e.target.classList.contains('js-addTag')) {
    return
  }
  const item = e.target
  const box = document.querySelector('.js-addTag-frame .js-addTag-box')

  if (item.checked) {
    box.innerHTML += `
<div class="js-addTag-item searchForm__tag" data-value="${item.value}">
      ${item.dataset.label}
      <input type="hidden" name="${item.name}" value="${item.value}">
</div>
`
  } else {
    const delTag = box.querySelector('.js-addTag-item[data-value="' + item.value + '"]')
    delTag.parentNode.removeChild(delTag)
  }

  // タグの長さからボックス幅を設定
  tagBoxUpdate(box)
})

setTimeout(() => {
  const checkTagList = document.querySelectorAll('.js-addTag:checked')
  console.log(checkTagList)

  if (checkTagList[0]) {
    const box = document.querySelector('.js-addTag-frame .js-addTag-box')
    for (const item of checkTagList) {
      box.innerHTML += `
<div class="js-addTag-item searchForm__tag" data-value="${item.value}">
      ${item.dataset.label}
      <input type="hidden" name="${item.name}" value="${item.value}">
</div>
`
    }

    // タグの長さからボックス幅を設定
    tagBoxUpdate(box)
  }
}, 500)

//  #####    #####   ##    ##            ##   ##  #####   ####      ###    ######  #####
//  ##  ##  ##   ##   ##  ##             ##   ##  ##  ##  ##  ##   ## ##     ##    ##
//  #####   ##   ##    ####    ########  ##   ##  #####   ##  ##  ##   ##    ##    #####
//  ##  ##  ##   ##   ##  ##             ##   ##  ##      ##  ##  #######    ##    ##
//  #####    #####   ##    ##             #####   ##      ####    ##   ##    ##    #####

// タグボックスの幅を決める
function tagBoxUpdate(box, scroll = true) {
  // 選択中のタグがなければボックスを消す
  if (box.innerText === '') {
    box.classList.remove('active')
  } else {
    box.classList.add('active')
  }

  const itemList = box.querySelectorAll('div')
  let itemWidth = 0
  for (const item of itemList) {
    itemWidth += item.offsetWidth + 15
  }

  itemWidth = itemWidth <= 700 ? itemWidth : 700

  box.style.width = itemWidth + 'px'

  // 入力欄の最大幅も調整する
  box.nextElementSibling.style.maxWidth = 'calc(100% - ' + itemWidth + 'px)'

  if (scroll) {
    // 最後のタグ位置までスクロール
    const lastTag = box.querySelector('div:last-child')
    if (lastTag) {
      // lastTag.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
    }
  }
}
// 初回起動
window.tagBoxSetup = function () {
  const boxList = document.querySelectorAll('.js-addTag-frame .js-addTag-box')
  for (const box of boxList) {
    tagBoxUpdate(box, false)
  }
}
window.tagBoxSetup()

//  ##   ##  ##   ####              ###        ##    ###    ##    ##
//  ##   ##  ##  ##                ## ##       ##   ## ##    ##  ##
//  #######  ##   ###   ########  ##   ##      ##  ##   ##    ####
//  ##   ##  ##     ##            #######  ##  ##  #######   ##  ##
//  ##   ##  ##  ####             ##   ##   ####   ##   ##  ##    ##

hisAjax()
function hisAjax() {
  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する

  let ajaxWord = null
  if (document.getElementsByClassName('js-hisAjax')) {
    window.addEventListener('click', (e) => {
      setSend(e)
    })
    window.addEventListener('input', (e) => {
      setSend(e)
    })
  }
  function setSend(e) {
    if (e.target.classList.contains('js-hisAjax')) {
      e.preventDefault()
      const item = e.target
      const inputKeyword = item.value.trim() // スペース等を除去した入力内容を取得
      // if (ajaxWord === inputKeyword) {
      //   // キーワードが変わっていなければ処理しない
      //   return false
      // }
      ajaxWord = inputKeyword

      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const to = item.dataset.to // 差し替え要素

      // 検索履歴は1つ前のフォームに適用するのでターゲットIDを補正する
      const idHead = item.id.replace(/[^A-Z^a-z^#^\.^-]/g, '')
      const idNum = parseInt(item.id.replace(/[^0-9]/g, ''), 10) - 1

      // console.log(item.id)
      // console.log(idHead + idNum)

      applyTagAjax(url, to, idHead + idNum)
    }
  }
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param id {string} inputのID
   */
  function applyTagAjax(url, to, id) {
    to = to.split(',') // ,区切りで配列に変換

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    ajax.open('GET', url, true) // GET/POST, URL, 非同期処理
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    ajax.responseType = 'json' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    ajax.send() // リクエスト実行
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (ajax.response === ajaxResponse) {
        // 前と結果が同じなら何もしない
        return
      }
      ajaxResponse = ajax.response // 取得結果を更新

      let ajaxData = ajaxResponse // 実際に使用するデータ

      // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
        ajaxData = JSON.parse(ajaxData)
      }

      let html = ''

      // 取得したJSONをタグに加工する
      let isHit = false
      for (let index = 0; index < ajaxData.length; index++) {
        const tag = ajaxData[index]
        // console.log(ajaxData[index])

        if (tag === ajaxWord) {
          continue // 入力内容と同じ単語はスキップ
        }
        html += `
<button type="button" class="js-his-insert searchForm__item flex vcenter bet" data-text="${tag}" data-input="${id}" data-keyword="${ajaxData[index]['keyword']}" data-tag="${ajaxData[index]['tag']}">
      ${ajaxData[index]['view']}
</button>
`
        isHit = true
      }

      for (let index = 0; index < to.length; index++) {
        const itemTo = document.querySelector(to[index])
        itemTo.innerHTML = html
        if (isHit) {
          itemTo.classList.add('active')
        } else {
          itemTo.classList.remove('active')
        }
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      ajax = false
    }
  }
}
/*
         #### ##    ##  ######  ######## ########  ########
          ##  ####  ## ##       ##       ##     ##    ##
 #######  ##  ## ## ##  ######  ######   ########     ##
          ##  ##  ####       ## ##       ##   ##      ##
         #### ##    ##  ######  ######## ##     ##    ##
*/

window.addEventListener('click', function (e) {
  // 指定のクラスを持たない
  if (!e.target.classList.contains('js-his-insert')) {
    return
  }

  // サジェストボックスを非表示
  e.target.parentNode.classList.remove('active')

  // 入力を反映
  const inputID = e.target.dataset.input
  const focusInput = document.getElementById(inputID) // フォーカスする入力欄を確定
  focusInput.value = e.target.dataset.keyword

  // タグを反映
  const box = focusInput.closest('.js-searchArea').querySelector('.js-addTag-box')

  const tagText = e.target.dataset.tag
  // console.log(tagText)

  const json = JSON.parse(decodeURIComponent(tagText)) // テキストをJSONにパース

  box.innerHTML = '' // 一旦クリア

  for (const key in json) {
    const name = json[key]['name']
    const value = json[key]['value']

    console.log({ name })
    console.log({ value })

    box.innerHTML += `
<div class="js-addTag-item searchForm__tag" data-value="${value}">
      ${name}
      <input type="hidden" name="tags[]" value="${value}">
</div>
`

    // 関連するチェックを入れる
    const checkList = document.querySelectorAll('[type="checkbox"][value="' + value + '"]')
    for (const element of checkList) {
      element.checked = true
    }
  }

  // タグの長さからボックス幅を設定
  tagBoxUpdate(box)

  // サジェストをクリア
  const suggestBox = document.getElementsByClassName('js-search-suggest')
  for (let index = 0; index < suggestBox.length; index++) {
    suggestBox[index].innerHTML = ''
  }

  focusInput.focus() // フォーカスを戻す
})

//   ####  ##   ##  #####   ####  ##  ##             ####  ##    ##  ##     ##   ####
//  ##     ##   ##  ##     ##     ## ##             ##      ##  ##   ####   ##  ##
//  ##     #######  #####  ##     ####    ########   ###     ####    ##  ## ##  ##
//  ##     ##   ##  ##     ##     ## ##                ##     ##     ##    ###  ##
//   ####  ##   ##  #####   ####  ##  ##            ####      ##     ##     ##   ####
/*
data-check-syncが同じチェックボックスを同期する
<input class="js-checkSync" type="checkbox" value="" name="" data-check-sync="check1">
<input class="js-checkSync" type="checkbox" value="" name="" data-check-sync="check1">
*/
if (document.getElementsByClassName('js-checkSync')[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-checkSync')) {
      return
    }
    const checkList = document.querySelectorAll('[data-check-sync="' + e.target.dataset.checkSync + '"]')
    for (const checkbox of checkList) {
      checkbox.checked = e.target.checked
    }
  })
}

//  ######    ###     ####              ####    #####  ##
//    ##     ## ##   ##                 ##  ##  ##     ##
//    ##    ##   ##  ##  ###  ########  ##  ##  #####  ##
//    ##    #######  ##   ##            ##  ##  ##     ##
//    ##    ##   ##   ####              ####    #####  ######
// BackSpaceでタグを消す

if (document.getElementsByClassName('js-tagEdit')[0]) {
  window.addEventListener('keydown', function (e) {
    if (!e.target.classList.contains('js-tagEdit')) {
      return
    }
    // 入力欄の先頭でBackSpaceした場合だけ処理
    if (e.target.selectionStart !== 0 || e.key !== 'Backspace') {
      return
    }
    const box = e.target.previousElementSibling
    const item = box.querySelector('div:last-child')
    if (item) {
      tagDel(box, item) // タグボックス側からタグを消す
    }
  })
}

//  ####    #####  ##
//  ##  ##  ##     ##
//  ##  ##  #####  ##
//  ##  ##  ##     ##
//  ####    #####  ######
// タグボックス側からタグを消す
function tagDel(box, item) {
  const value = item.dataset.value

  // タグを消す
  item.parentNode.removeChild(item)

  // チェックボックスを切る
  const checkList = document.querySelectorAll('.js-addTags[value="' + value + '"]')
  for (const iterator of checkList) {
    iterator.checked = false
  }

  // タグの長さからボックス幅を設定
  tagBoxUpdate(box)
}

//  ####    ##   ####            ##  ##  #####  ##    ##
//  ##  ##  ##  ##               ## ##   ##      ##  ##
//  ##  ##  ##   ###   ########  ####    #####    ####
//  ##  ##  ##     ##            ## ##   ##        ##
//  ####    ##  ####             ##  ##  #####     ##
// キー入力を無効化
window.addEventListener('keypress', function (e) {
  keyCheck(e)
})
window.addEventListener('input', function (e) {
  keyCheck(e)
})
function keyCheck(e) {
  const item = e.target.closest('.js-keyDisable')
  if (!item) {
    return
  }
  // Enter以外のキー入力を防止
  if (e.code && e.code !== 'Enter') {
    e.preventDefault() // デフォルトのイベントを除去
    return false
  }
}
